module.exports = __webpack_public_path__ + "media/images/new_culture/bg-11-256ad063a16897ebe03649e6cd066b47.jpeg";